import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import { previewMixin } from '../mixin/preview.js';
import { linkageMixin } from '../mixin/linkage';
import { PtButtonType as _PtButtonType, PtButtonTheme as _PtButtonTheme, PtButtonSize as _PtButtonSize } from '@com/pt-components/pt-button/enum';

export default {
  mixins: [previewMixin, linkageMixin],

  props: {
    category: {
      type: Object,
      required: true
    },

    updateTargetCategory: {
      type: Function,
      required: true
    }
  },

  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    previewer: function previewer(state) {
      return state.creative.template.previewer;
    }
  }), {
    visibleStatus: function visibleStatus() {
      return this.category.properties && this.category.properties.visible || 1;
    },
    iconClass: function iconClass() {
      return this.visibleStatus === 1 ? 'visible' : 'hidden';
    },
    PtButtonType: function PtButtonType() {
      return _PtButtonType;
    },
    PtButtonTheme: function PtButtonTheme() {
      return _PtButtonTheme;
    },
    PtButtonSize: function PtButtonSize() {
      return _PtButtonSize;
    }
  }),

  methods: _extends({}, mapActions({
    livePreviewResources: 'creative/template/livePreviewResources',
    livePreviewJsonConfig: 'creative/template/livePreviewJsonConfig'
  }), {
    toggleVisible: function toggleVisible() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var visibleStatus;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                visibleStatus = _this.visibleStatus === 1 ? 2 : 1;

                _this.visibleCategory({
                  category: _this.category,
                  visibleStatus: visibleStatus
                });

                if (!_this.canLivePreview) {
                  _context.next = 7;
                  break;
                }

                _this.livePreviewResources();
                _this.livePreviewJsonConfig();
                _context.next = 9;
                break;

              case 7:
                _context.next = 9;
                return _this.previewAfterPackaging();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    visibleCategory: function visibleCategory(_ref) {
      var _this2 = this;

      var category = _ref.category,
          visibleStatus = _ref.visibleStatus;

      var oldProperties = _.cloneDeep(category.properties || {});

      var newProperties = _.cloneDeep(category.properties || {});
      newProperties.visible = visibleStatus;
      // 背景颜色隐藏时，更新背景颜色
      if (category.isGlobalConfig && category.isBgColor) {
        var globalConfig = newProperties.globalConfig;
        var oldGlobalConfig = oldProperties.globalConfig;
        if (visibleStatus === 2) {
          // 背景色隐藏时，将 bgColor 设置为空字符串（不能为 transparent）。因为背景色的脚本判断背景色不为空就赋值，如果设置了背景色为 transparent，背景图片将失效。
          globalConfig.value = '';
          globalConfig.visibleValue = oldGlobalConfig.value;
        } else {
          globalConfig.value = oldGlobalConfig.visibleValue || oldGlobalConfig.originalValue;
          globalConfig.visibleValue = '';
        }
        newProperties.globalConfig = globalConfig;
      }
      this.updateTargetCategory({
        properties: newProperties,
        id: category.id
      });
      if (category.sub_category && category.sub_category.length) {
        category.sub_category.forEach(function (item) {
          _this2.visibleCategory({
            category: item,
            visibleStatus: visibleStatus
          });
        });
      }
    }
  })
};